export const Titles = {
  // Orders
  OrderDateAndHour: "Data e hora",
  OrderValue: "Valor do pedido",
  OrderDeliveryFee: "Taxa de entrega",
  OrderBrand: "Marca",
  OrderUnit: "Unidade",
  OrderSourceData: "Fonte da venda",
  OrderOriginSale: "Origem da venda",
  OrderCity: "Cidade",
  OrderState: "Estado",
  OrderCountry: "País",
  OrderNeighborhood: "Bairro",
  OrderTemperature: "Temperatura",
  OrderThermalSensation: "Sensação térmica",
  OrderMoisture: "Umidade",
  OrderClimaticFeature: "Característica climática",
  OrderYear: "Ano em que pediu",
  OrderDay: "Dia do pedido",
  OrderWeek: "Semana do pedido",
  OrderDayWeek: "Dia da semana do pedido",
  OrderMonth: "Mês em que pediu",
  // Customers
  CustomerAge: "Idade",
  CustomerDateAndHour: "Data e hora do cadastro",
  CustomerName: "Nome do cliente",
  CustomerEmail: "Email do cliente",
  CustomerPhone: "Telefone do cliente",
  CustomerDoc: "CPF do cliente",
  CustomerBirthday: "Aniversário do cliente",
  CustomerGender: "Gênero do cliente",
  CustomerLastAtt: "Última atualização",
  CustomerTotalSpend: "Total gasto",
  CustomerQuantityOrders: "Quantidade de pedidos",
  CustomerRFV: "Perfil RFV do cliente",
  CustomerAverageTicket: "Ticket médio",
  CustomerFrequencyOrders: "Frequência de pedidos",
  CustomerLastOrder: "Data do último pedido",
  CustomerDaysWithoutConversion: "Dias sem pedir",
  CustomerMarketing: "Recebe marketing",
  CustomerHourRegistration: "Hora de cadastro do cliente",
  CustomerDayRegistration: "Dia de cadastro do cliente",
  CustomerWeekRegistration: "Semana de cadastro do cliente",
  CustomerDayWeekRegistration: "Dia da semana de cadastro do cliente",
  CustomerYearRegistration: "Ano de cadastro do cliente",
  CustomerMonthRegistration: "Mês de cadastro do cliente",
  // Coupons
  CouponDayAndHour: "Data e hora de uso",
  CouponCode: "Código do cupom",
  CouponType: "Tipo do cupom",
  CouponDiscount: "Desconto do cupom",
  CouponMinOrder: "Pedido mínimo do cupom",
  CouponDaysExp: "Dias para expirar",
  CouponExpDate: "Data de expiração",
  CouponExpDateReminder: "Data do lembrete de expiração",
  CouponHour: "Hora do uso",
  CouponDay: "Dia do uso",
  CouponWeek: "Semana do uso",
  CouponDayWeek: "Dia da semana do uso",
  CouponMonth: "Mês do uso",
  CouponYear: "Ano do uso",
  // Products
  ProductDayAndHour: "Data e hora de consumo",
  ProductSKU: "Código SKU",
  ProductName: "Nome do produto consumido",
  ProductQuantity: "Quantidade consumida",
  ProductHour: "Hora de consumo",
  ProductValue: "Valor quando foi consumido",
  ProductSize: "Nome do tamanho",
  ProductCategory: "Nome da categoria",
  ProductYear: "Ano do consumo",
  ProductMonth: "Mês do consumo",
  ProductDay: "Dia do consumo",
  ProductWeek: "Semana de consumo",
  ProductDayWeek: "Dia da semana em que consumiu",
  // Profiles
  ProfileRFV: "Perfil RFV",
  ProfileClimate: "Perfil climático",
  ProfileMomentWeek: "Perfil de momento na semana",
  ProfileMomentDay: "Perfil de momento no dia",
  ProfileSeason: "Perfil de estação",
  ProfileTemperature: "Perfil de temperatura",

  "c.rfv_profile": "Perfil de performance",
  "c.tag_climate": "Perfil climático",
  "c.tag_temperature": "Temperatura em que pedem",
  "c.tag_period_day": "Quando pedem",
  "c.tag_period_week": "Período em que pedem",  
};
